// extracted by mini-css-extract-plugin
export default {"optionsContainer":"style_optionsContainer__DXUYJ","btn":"style_btn__zXSYV"};